import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const PAGES = [
    {
        label: "From Part One — The Garden",
        title: "The Boy Who Came Through Her",
        paras: [
            "Eve was alone in the garden, and she was whole. Then life quickened within her — how, the story never tells, and the mystery is meant to remain a mystery. She carried him. She bore him. She held him against her chest, and named him Adam.",
            "She raised him. She taught him. And every day he picked a rose and placed it beside her ear, because to him, she was the most beautiful flower in the garden.",
        ],
    },
    {
        label: "From Part One — The Garden",
        title: "What Strength Is For",
        paras: [
            "When he cried, she did not tell him to stop. When he was afraid, she held him. When he was angry, she knelt beside him and asked one question: what hurts?",
            "\u201CYour strength is not for ruling over life,\u201D she told him. \u201CIt is for protecting it.\u201D",
        ],
    },
    {
        label: "From Part One — The Garden",
        title: "The True Fall",
        paras: [
            "When she died, he dug her grave with his own hands, and laid the last rose on the earth — and there was no ear left to place one beside.",
            "Then he whispered the words the serpent was waiting to hear: \u201CI wish I didn\u2019t have to feel this.\u201D",
            "The serpent came not as a monster, but as a whisper. Love less, and you will hurt less. Adam listened. He built a wall around his heart. This is the true Fall.",
        ],
    },
];

export default function LookInside({ open, onClose }) {
    const [page, setPage] = useState(0);

    if (!open) return null;

    return (
        <motion.div
            className="look-overlay"
            data-testid="look-inside-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
        >
            <motion.div
                initial={{ opacity: 0, y: 40, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="book-page relative w-full max-w-xl rounded-sm px-8 py-12 sm:px-14 sm:py-16"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    onClick={onClose}
                    data-testid="look-close-button"
                    aria-label="Close preview"
                    className="absolute right-4 top-4 text-[#6a5a40] transition-colors duration-300 hover:text-[#2b2416]"
                >
                    <X size={22} />
                </button>

                <AnimatePresence mode="wait">
                    <motion.div
                        key={page}
                        data-testid={`look-page-${page + 1}`}
                        initial={{ opacity: 0, x: 24 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: -24 }}
                        transition={{ duration: 0.45 }}
                    >
                        <p className="font-cinzel text-[0.65rem] tracking-[0.4em] text-[#8a7a60] uppercase">
                            {PAGES[page].label}
                        </p>
                        <h3 className="font-cinzel mt-4 text-2xl text-[#2b2416] sm:text-3xl">
                            {PAGES[page].title}
                        </h3>
                        <div className="mt-6 space-y-5">
                            {PAGES[page].paras.map((p, i) => (
                                <p key={i} className={`font-cormorant text-lg leading-relaxed text-[#3d3423] sm:text-xl ${i === 0 ? "drop-cap" : ""}`}>
                                    {p}
                                </p>
                            ))}
                        </div>
                    </motion.div>
                </AnimatePresence>

                <div className="mt-10 flex items-center justify-between">
                    <button
                        onClick={() => setPage((p) => Math.max(0, p - 1))}
                        disabled={page === 0}
                        data-testid="look-prev-button"
                        aria-label="Previous page"
                        className="text-[#6a5a40] transition-opacity duration-300 hover:text-[#2b2416] disabled:opacity-25"
                    >
                        <ChevronLeft size={26} />
                    </button>
                    <p className="font-cinzel text-[0.65rem] tracking-[0.3em] text-[#8a7a60] uppercase">
                        Page {page + 1} of {PAGES.length}
                    </p>
                    <button
                        onClick={() => setPage((p) => Math.min(PAGES.length - 1, p + 1))}
                        disabled={page === PAGES.length - 1}
                        data-testid="look-next-button"
                        aria-label="Next page"
                        className="text-[#6a5a40] transition-opacity duration-300 hover:text-[#2b2416] disabled:opacity-25"
                    >
                        <ChevronRight size={26} />
                    </button>
                </div>

                <p className="font-cormorant mt-6 text-center text-sm italic text-[#8a7a60]">
                    Sample preview — final text from the forthcoming first edition.
                </p>
            </motion.div>
        </motion.div>
    );
}
